const isVoiceMessageId = (id) => typeof id === "string" && id.startsWith("voice-");
const toIsoString = (value) => {
  if (!value) return "";
  if (value instanceof Date) return value.toISOString();
  return value;
};
const toEpochMs = (value) => {
  if (!value) return NaN;
  if (value instanceof Date) return value.getTime();
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? NaN : parsed;
};
function buildVoiceSegments(messages) {
  var _a, _b, _c;
  const out = [];
  let i = 0;
  let segmentIndex = 0;
  while (i < messages.length) {
    const current = messages[i];
    if (!isVoiceMessageId(current.id)) {
      out.push({ kind: "message", message: current, segmentKey: null });
      i += 1;
      continue;
    }
    const runStart = i;
    let runEnd = i;
    while (runEnd < messages.length && isVoiceMessageId(messages[runEnd].id)) {
      runEnd += 1;
    }
    const segmentKey = `voice-segment-${segmentIndex++}`;
    const runMessages = messages.slice(runStart, runEnd);
    const firstTs = toEpochMs((_a = runMessages[0]) == null ? void 0 : _a.createdAt);
    const lastTs = toEpochMs((_b = runMessages[runMessages.length - 1]) == null ? void 0 : _b.createdAt);
    const durationSec = Number.isFinite(firstTs) && Number.isFinite(lastTs) && lastTs >= firstTs ? Math.max(0, Math.round((lastTs - firstTs) / 1e3)) : 0;
    const turnCount = runMessages.filter((m) => m.role === "user").length;
    const tWallStartIso = toIsoString((_c = runMessages[0]) == null ? void 0 : _c.createdAt);
    out.push({
      kind: "voice-segment-header",
      segmentKey,
      durationSec,
      turnCount,
      tWallStartIso,
      messageCount: runMessages.length
    });
    for (const m of runMessages) {
      out.push({ kind: "message", message: m, segmentKey });
    }
    i = runEnd;
  }
  return out;
}
export {
  buildVoiceSegments,
  isVoiceMessageId
};
//# sourceMappingURL=voiceSegments.js.map
